/* eslint-disable import/prefer-default-export */
export function formatAddress(address) {
  if (!address) return '-';
  return `${address.street || ''}${address.street ? ', ' : ''}${address.zipCode || ''}${address.zipCode ? ' ' : ''}${address.city || ''}`;
}



// WEBPACK FOOTER //
// ./routes/cpm/routes/accounts/utils/utils.js